// 列表页通用代码
import dayjs from "dayjs";
import { mapState } from 'vuex';
import { page } from '@/api/permission/menu';
export default {
    data() {
        return {
            loading: false,
            // 总条数
            total: 0,
            // 列表表格数据
            tableData: [],
            // 查询参数
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            menuList: [],
        };
    },
    computed: {
        ...mapState(["menuIds"]),
    },
    created() {
        this.search();
        this.getMenuList();
    },
    methods: {
        permission(uri) {
            const target = this.menuList.find(item => item.uri == uri);
            if (!target) return false;
            return this.menuIds.includes(target.id);
        },
        getMenuList() {
            page({
                pageNo: 1,
                pageSize: 9999
            }).then(({ code, result }) => {
                if (code == 200) {
                    this.menuList = result.records;
                }
            })
        },
        handleSizeChange(size) {
            this.query.pageSize = size;
            this.handleSearch();
        },
        handleCurrentChange(current) {
            this.query.pageNo = current;
            this.search();
        },
        handleSearch() {
            this.query.pageNo = 1;
            this.search();
        },
        resetQuery() {
            this.handleSearch();
        },
        formatDate(date) {
            return dayjs(date).format("YYYY-MM-DD HH:mm");
        },
    },
};
